module.exports = "/images/left-arrow.svg?813604009ab7c15255ce3506616721b8";